// components/Content.tsx
import React from "react";
import { ContentProps } from "./types";
import Step from "./Step";
import { useTutorial } from "./TutorialContext";

const Content: React.FC<ContentProps> = ({ onStepLoad, ...props }) => {
  const { formdata } = useTutorial();

  return (
    <div className="q-tut-card-cont" {...props}>
      {formdata.map((step, index) => (
        <Step
          key={index}
          {...step}
          index={index}
          isLast={index === formdata.length - 1}
        />
      ))}
    </div>
  );
};

export default Content;
